import moment from 'moment';
import {DATETIME_FORMAT} from './date.model';

export class MercureModel {
  country: string;
  mercureData: MercureDataModel[];
}

export class MercureDataModel {
  pvFc: number;
  resLoad: number;
  ts: string;
  windFc: number;

  constructor(objIn: any) {
    this.pvFc = objIn.SOLAR_FORECAST || null;
    this.resLoad = objIn.RESLOAD_FORECAST || null;
    this.ts = objIn.timestamp
      ? moment.utc(objIn.timestamp).local().format(DATETIME_FORMAT)
      : '';
    this.windFc = objIn.WIND_FORECAST || null;
  }
}
